module.exports = __webpack_public_path__ + "img/mazda.c3215100.png";